import React from 'react';
import { Page, Card, TableProps } from 'components';
import styled from 'styled-components';

import CoopOrgTable from './CoopOrgTable';

const ContractsPage: React.FC = () => (
    <Page type="filled" title="Key Co-ops" showBackButton fillScreenHeight>
      <StyledContainer>
        <Card>
          <p>
            Your key is configured with access to lockboxes from the
            organizations in the table below.
          </p>
          <p>
            <b>Auto Co-op:</b>
            <span> These organizations have a key cooperation agreement.</span>
            <br />
            <b>Manual Co-op:</b>
            <span>
              {' '}
              You have manually co-oped your key into this organization.
            </span>
          </p>
        </Card>
        <CoopOrgTable />
      </StyledContainer>
    </Page>
  );

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  width: 50%;
  gap: 20px;
`;

export default ContractsPage;
